import { Grid, Typography, useTheme } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import React, { useEffect, useState } from "react";
import { useCurrentDashboard } from "../useCurrentDashboard";
import { SignalsDashboardType } from "../SignalsModels";
import { Edit } from "@mui/icons-material";

// Component for displaying and editing the dashboard title
export const DashboardTitle = () => {
    const currentDashboard = useCurrentDashboard();

    const [editingDashTitle, setEditingDashTitle] = useState(false);
    const [dashboardTitle, setDashboardTitle] = useState(
        currentDashboard?.title || "",
    );
    const [isHovered, setIsHovered] = useState(false);

    const enableEditDashboardTitle =
        currentDashboard?.dashboardType === SignalsDashboardType.Custom &&
        currentDashboard?.dashboardIsEditable &&
        !currentDashboard?.isPresentationMode;

    const theme = useTheme();

    useEffect(() => {
        setDashboardTitle(currentDashboard?.title || "");
    }, [currentDashboard?.title]);

    return (
        <Grid
            item
            display={"flex"}
            alignItems={"center"}
            style={{
                cursor: enableEditDashboardTitle ? "pointer" : "auto",
            }}
            onMouseEnter={() => {
                if (enableEditDashboardTitle) {
                    setIsHovered(true);
                }
            }}
            onMouseLeave={() => {
                if (enableEditDashboardTitle) {
                    setIsHovered(false);
                }
            }}
            onClick={() => {
                if (enableEditDashboardTitle) {
                    setEditingDashTitle(true);
                }
            }}
            id="dashboard-title"
        >
            <Typography
                variant="h1"
                style={{
                    fontSize: "24px",
                }}
            >
                {editingDashTitle && enableEditDashboardTitle ? (
                    <AcxMainTextField
                        id="edit-dashboard-title-input"
                        value={dashboardTitle}
                        onChange={(e) => {
                            setDashboardTitle(e.target.value);
                        }}
                        onBlur={async () => {
                            setEditingDashTitle(false);
                            if (!currentDashboard) return;

                            await currentDashboard.updateDashboard({
                                logoName: currentDashboard.logoName,
                                pinnedApplicationFilterId:
                                    currentDashboard.pinnedApplicationFilterId,
                                title: dashboardTitle,
                            });
                        }}
                        blurOnEnterPress
                    />
                ) : (
                    dashboardTitle
                )}
            </Typography>

            {enableEditDashboardTitle && (
                <Grid
                    sx={{
                        visibility:
                            isHovered && !editingDashTitle
                                ? "visible"
                                : "hidden",
                    }}
                    item
                    display={"flex"}
                    alignItems={"center"}
                >
                    <Edit
                        style={{
                            width: "20px",
                            height: "20px",
                            color: theme.palette.gray.main,
                            marginLeft: "4px",
                            marginTop: "2px",
                        }}
                    />
                </Grid>
            )}
        </Grid>
    );
};
